import { OfferLite } from '@/business/offers/models/offer-lite'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { NumberMap } from '@/shared/utils/map'
import { LookupItem } from '@/api/generated'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'

export interface SharedState {
  categories: LookupItem[]
  offerMap: NumberMap<OfferLite>
  offers: OfferLite[]
  organisations: OrganisationLite[]
  organisationMap: NumberMap<OrganisationLite>
  resources: ResourceViewModel[]
}

export function emptySharedState(): SharedState {
  return {
    categories: [],
    offerMap: {},
    offers: [],
    organisationMap: {},
    organisations: [],
    resources: [],
  }
}
